import React from 'react';
import { Box, FormControlLabel, Switch, Tooltip } from '@mui/material';

/**
 * RoleToggleSwitch - Component for switching between teacher and admin views
 * 
 * @param {Object} props - Component props
 * @param {string} props.userType - The user's role type
 * @param {string} props.typeOfUser - The current active role
 * @param {Object} props.user - The user object containing roles
 * @param {Function} props.handleRoleToggle - Function to handle role switching
 * @returns {JSX.Element|null} Rendered switch component or null if not applicable
 */
const RoleToggleSwitch = React.memo(({ 
  userType, 
  typeOfUser, 
  user, 
  handleRoleToggle 
}) => {
  const shouldShowSwitch = 
    (userType === 'TEACHER' || userType === 'SCHOOLADMIN') &&
    Array.isArray(user?.roles) &&
    user.roles.length > 1;

  if (!shouldShowSwitch) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        paddingLeft: 1,
      }}
    >
      <Tooltip
        title={`Switch to ${
          typeOfUser === 'SCHOOLADMIN' ? 'TEACHER' : 'SCHOOLADMIN'
        } View`}
        placement='left'
      >
        <FormControlLabel
          control={
            <Switch
              checked={typeOfUser === 'SCHOOLADMIN'}
              onChange={(e) =>
                handleRoleToggle(
                  e.target.checked ? 'SCHOOLADMIN' : 'TEACHER'
                )
              }
              sx={{
                '& .MuiSwitch-switchBase.Mui-checked': {
                  color: 'var(--clr-theme-purple)',
                },
                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                  backgroundColor: 'var(--clr-theme-purple)',
                },
              }}
            />
          }
          label={
            typeOfUser === 'SCHOOLADMIN'
              ? 'Admin View'
              : 'Teacher View'
          }
          labelPlacement='end'
          sx={{
            px: 1.5,
            py: 0.5,
            gap: 3,
            width: '100%',
          }}
        />
      </Tooltip>
    </Box>
  );
});

export default RoleToggleSwitch; 